import { render, staticRenderFns } from "./InvL_List.vue?vue&type=template&id=3ca44e0c"
import script from "./InvL_List.vue?vue&type=script&lang=js"
export * from "./InvL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports